import { global } from "../../constants";

export const data = {
  
    banner: {
    base: "Servicios",
    background: global.banner + "administrative-processes.webp",
    title: "Procesos Administrativos",
    crumb: "Procesos Administrativos",
  },

  icon: "fa-solid fa-clipboard-list",
  shortDescription:
    "Diseño, control y ejecución de los procesos administrativos esenciales para operaciones Ship-to-Ship (STS), garantizando seguridad, eficiencia y cumplimiento normativo conforme a OCIMF.",
  title: "Procesos Administrativos",
  features: {
    title: "Procesos Administrativos Clave en Servicios STS",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Planeación, organización, dirección y control integrados a la gestión operativa y de cumplimiento internacional para operaciones de transferencia barco a barco (STS).",
    description: `Los servicios STS requieren un sistema administrativo robusto que combine eficiencia logística con cumplimiento internacional (OCIMF/ISGOTT). Nuestra metodología se basa en seis procesos clave que aseguran continuidad operativa, mitigación de riesgos y trazabilidad documental en cada maniobra.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "planificacion_logistica",
        title: "Planificar la Capacidad Operacional y Logística",
        summary:
          "Evaluación y planificación estratégica de recursos humanos, técnicos y materiales para garantizar disponibilidad y seguridad en cada operación STS.",
        details:
          "Desarrollamos planes de capacidad que incluyen la asignación de buques de apoyo, defensas, mangueras y equipos de contingencia. Incluye análisis de riesgos por zona de transferencia, estudios meteorológicos, revisión de habilitaciones portuarias y planificación de descanso y disponibilidad del POAC/Mooring Master. Se incorpora la debida diligencia (Due Diligence) de locaciones y contratistas para asegurar cumplimiento y eficiencia.",
        deliverables: [
          "Plan de capacidad operacional STS",
          "Evaluación de riesgos de locación y equipo",
          "Informe de disponibilidad de recursos humanos críticos"
        ],
        requiredDocs: [
          "Plan maestro de operaciones STS",
          "Certificados de equipos y embarcaciones",
          "Registros de disponibilidad y rotación de personal"
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "administrative_processes/1.webp",
      },
      {
        key: "organizacion_rrhh",
        title: "Organizar y Formalizar el Equipo Humano Especializado",
        summary:
          "Estructura jerárquica clara y gestión profesional del talento marítimo y de emergencia para garantizar la coordinación operativa.",
        details:
          "Diseñamos organigramas funcionales que delimitan responsabilidades en la cadena STS: POAC, capitanes, oficiales de seguridad, operadores y equipo de crisis. La gestión de recursos humanos (HRM) incluye verificación de certificados STCW, control de caducidades, registro de experiencia en maniobras y plan de entrenamiento recurrente. El objetivo es asegurar competencia, trazabilidad y respuesta ante incidentes.",
        deliverables: [
          "Manual de estructura y delegación de autoridad",
          "Registro de certificaciones STCW y experiencia POAC",
          "Plan anual de entrenamiento y simulacros"
        ],
        requiredDocs: [
          "Certificados del personal clave",
          "Bitácoras de operaciones previas",
          "Registros de entrenamiento y evaluaciones"
        ],
        icon: "fa-solid fa-users-gear",
        image: global.services + "administrative_processes/2.webp",
      },
      {
        key: "control_normativo",
        title: "Controlar el Cumplimiento Normativo y la Documentación",
        summary:
          "Auditoría documental integral previa a cada operación STS para asegurar conformidad con normativa marítima y de seguridad.",
        details:
          "Implementamos unidades de gestión documental que validan certificados de buques, tripulación y carga (MSDS, COA, DOC, SMC, ISM, etc.). Se realiza auditoría digital previa al zarpe, asegurando trazabilidad, consistencia y cumplimiento de las guías OCIMF/ISGOTT. Este control reduce riesgos de sanciones, rechazos o retrasos operativos.",
        deliverables: [
          "Checklist documental STS (pre-operación)",
          "Auditoría digital de cumplimiento normativo",
          "Sistema de control de versiones y trazabilidad"
        ],
        requiredDocs: [
          "Certificados del buque y tripulación",
          "Documentos de seguridad de carga (MSDS)",
          "Manuales y registros ISM/ISPS"
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "administrative_processes/3.webp",
      },
      {
        key: "direccion_operacional",
        title: "Dirigir la Ejecución Operacional y de Seguridad",
        summary:
          "Coordinación en tiempo real entre POAC y capitanes para garantizar la ejecución segura del Plan Operacional Conjunto.",
        details:
          "Durante la maniobra STS, se aplican las listas de chequeo oficiales OCIMF como herramienta de control y validación. La dirección incluye comunicación efectiva entre buques, supervisión del clima, verificación de parámetros de presión/flujo y la autoridad de suspender operaciones ante condiciones inseguras (viento, oleaje, fugas o derrames).",
        deliverables: [
          "Plan de operaciones conjunto (Joint STS Plan)",
          "Reportes de ejecución con observaciones POAC",
          "Registro de chequeos y condiciones meteorológicas"
        ],
        requiredDocs: [
          "Plan de operación aprobado",
          "Checklist OCIMF/STS vigente",
          "Bitácora del POAC y reportes de comunicación"
        ],
        icon: "fa-solid fa-compass-drafting",
        image: global.services + "administrative_processes/4.webp",
      },
      {
        key: "emergencias_contingencias",
        title: "Gestionar la Respuesta a Emergencias y Contingencias",
        summary:
          "Protocolos formalizados para respuesta inmediata ante incidentes marítimos, derrames o situaciones de emergencia en operaciones STS.",
        details:
          "Desarrollamos y entrenamos planes de contingencia (SOPEP, VRP) con activación jerárquica y comunicación inmediata con autoridades marítimas. Incluye acuerdos de cooperación con la Armada, aseguradoras y empresas de respuesta a emergencias. Los simulacros periódicos fortalecen la preparación del personal y la eficiencia de los procedimientos de emergencia.",
        deliverables: [
          "Plan de respuesta a emergencias STS (SOPEP/VRP)",
          "Manual de comunicación y cadena de mando",
          "Registro de simulacros y evaluaciones"
        ],
        requiredDocs: [
          "Plan SOPEP/VRP vigente",
          "Contratos con entidades de respuesta",
          "Listas de contactos y protocolos de emergencia"
        ],
        icon: "fa-solid fa-triangle-exclamation",
        image: global.services + "administrative_processes/5.webp",
      },
      {
        key: "auditoria_mejora",
        title: "Auditar la Mejora Continua y la Gestión Financiera",
        summary:
          "Monitoreo anual del desempeño operativo y financiero, integrando control de calidad, costos y cumplimiento normativo.",
        details:
          "Implementamos auditorías de desempeño y revisiones anuales de los procedimientos STS conforme a guías OCIMF. A nivel financiero, se revisa la transparencia contable, costos de seguridad, mantenimiento y seguros, integrando los mismos en un sistema ERP. Esto permite identificar oportunidades de mejora continua y justificar la inversión en cumplimiento como mitigación de riesgo operacional.",
        deliverables: [
          "Informe anual de desempeño operativo",
          "Auditoría financiera y de cumplimiento STS",
          "Plan de acción para mejora continua"
        ],
        requiredDocs: [
          "Registros contables y de costos STS",
          "Historial de incidentes o hallazgos",
          "Auditorías previas OCIMF o internas"
        ],
        icon: "fa-solid fa-chart-line",
        image: global.services + "administrative_processes/6.webp",
      },
    ],
  },
  ctaText: "Solicitar consultoría en procesos STS",
  ctaLink: "/contacto?servicio=procesos-administrativos-sts",
};